export default "__VITE_ASSET__lb3DcO$7__"